"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M4.01 2 4 22h16V8l-6-6zM13 9V3.5L18.5 9z"
}), 'InsertDriveFileSharp');